import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ZipcodeInternacionalFilters = Partial<{
  general_country_id: string;
  city: string;
  state: string;
  zipcode: string;
}>;

type PaginationControl = {
  page: number;
  limit: number;
};

type State = {
  filters: ZipcodeInternacionalFilters;
  paginationControl: PaginationControl;
};

type Actions = {
  updateFilters: (filters: ZipcodeInternacionalFilters) => void;
  updatePaginationControl: (
    paginationControl: Partial<PaginationControl>,
  ) => void;
  clearState: () => void;
};

const getInitialState = (): State => ({
  filters: {},
  paginationControl: {
    page: 1,
    limit: 10,
  },
});

export const useZipcodeInternacionalSearchParams = create<State & Actions>()(
  persist(
    (set) => ({
      ...getInitialState(),
      updateFilters: (filters) => set({ filters }),
      updatePaginationControl: (paginationControl) => {
        set((state) => ({
          paginationControl: {
            ...state.paginationControl,
            ...paginationControl,
          },
        }));
      },
      clearState: () => set(getInitialState()),
    }),
    {
      name: 'evonik-zipcode-internacional-search-params',
      version: 1,
    },
  ),
);
